import React from "react";

//hooks
import { DndProvider } from "react-dnd";
import { TouchBackend } from 'react-dnd-touch-backend';
import UseSimpleTable from "./SimpleTable.hooks";

//components

import LoadingSpinner from "../../loading/LoadingSpinner";
import DirectionalToggle from "../../toggles/DirectionalToggle/DirectionalToggle";

//interfaces
import { Direction } from "../../../../interfaces/toggles/IToggle";
import { ISimpleTableProps } from "../../../../interfaces/tables/ISimpleTable";
import DragAndDropRow from "./DragAndDropRow/DragAndDropRow";
import SimpleRow from "./SimpleRow/SimpleRow";



const SimpleTable = (
    {
        simpleTableContent, 
        noDataMessage, 
        isInfiniteScroll = false, 
        maxContentLength, 
        getMoreContent, 
        isDragAndDrop = false, 
        isPaginated = false, 
        paginationInformation, 
        infiniteScrollFetchCondition, 
        isLoading=true,
        hideActionsColumn
    }
    : ISimpleTableProps) => {

    const {
        noContentMessage,
        showNoContentMessage,
        infiniteScrollRef,
        displayedContent,
        hasControlsColumn,
        controlIndex,
        setControlIndex,
        toggleDirections,
        handleToggleDirection,
        containerRef,
        setHoverIndex,
        hoverIndex,
        moveRow,
        openMenu,
        setOpenMenu,
        defaultSortIsUnchecked,
        setDefaultSortIsUnchecked,
        isLoadingMore

    } = UseSimpleTable(
        simpleTableContent.rows,
        isInfiniteScroll, 
        getMoreContent, 
        maxContentLength, 
        noDataMessage, 
        infiniteScrollFetchCondition
    );


    return (
        <DndProvider backend={TouchBackend} options={{enableMouseEvents: true}}>
            <div className='rc-simple-table-wrapper' ref={containerRef}>
                <table className="rc-simple-table">

                    {/* table header */}
                    <thead className={`rc-simple-table-header`}>
                        <tr key={100}>
                            {simpleTableContent.columns.map((column, index) => (
                                column
                                    ?   (<th key={index}>
                                            {column.isToggleButton
                                                ?   (<DirectionalToggle 
                                                        direction={toggleDirections[index]}
                                                        sortAscending={() => (handleToggleDirection(index, Direction.UP), column.onSortAscendingClick())}
                                                        sortDescending={()=> (handleToggleDirection(index, Direction.DOWN), column.onSortDescendingClick())} 
                                                        text={column.title}
                                                        defaultSort={defaultSortIsUnchecked ? undefined : column.defaultSort}
                                                        onRemoveDefaultSort={() =>setDefaultSortIsUnchecked(true)}
                                                    />)
                                                :   <>{column.title}</> 
                                            }
                                        </th>)
                                    :   (<th className="rc-empty-column" />)

                            ))}
                            
                            {(isDragAndDrop || hasControlsColumn || isLoading) && !hideActionsColumn && <th className="rc-controls-column">Actions</th>}
                        </tr>
                    </thead>

                    {isLoading  
                        ?   (<tbody className="rc-full-width">
                                <tr><td className='rc-no-data-cell' colSpan={simpleTableContent.columns.length + ((isDragAndDrop || hasControlsColumn) ? 1 : 0)}>
                                    <span id="no-data-message" className="rc-no-data-message"><LoadingSpinner size={22}/></span>
                                </td></tr>
                            </tbody>)
                    
                        :   (showNoContentMessage
                                // when no content message is passed, show message
                                ?   <tbody className="full-width">
                                        <tr>
                                            <td className='rc-no-data-cell' colSpan={simpleTableContent.columns.length + ((isDragAndDrop || hasControlsColumn) ? 1 : 0)}>
                                                <span id="no-data-message" className="rc-no-data-message">{noContentMessage}</span>
                                            </td>
                                        </tr>
                                    </tbody> 
                                
                                // show content within the table
                                :   <tbody className={`rc-simple-table-body ${isDragAndDrop && "drag-and-drop"} `}> 
                                        {isDragAndDrop 
                                            ?   displayedContent.map((row, rowIndex) => (
                                                    <DragAndDropRow 
                                                        key={rowIndex} 
                                                        index={rowIndex} 
                                                        row={row} 
                                                        containerRef={containerRef} 
                                                        hoverIndex={hoverIndex} 
                                                        controlIndex={controlIndex} 
                                                        setControlIndex={setControlIndex} 
                                                        moveRow={moveRow} 
                                                        rowContentLength={displayedContent.length} 
                                                        setHoverIndex={setHoverIndex} 
                                                        openMenu={openMenu} 
                                                        setOpenMenu={setOpenMenu} 
                                                        dragAndDropAction={row.dragAndDropAction} 
                                                        isPaginated={isPaginated}
                                                        paginationInformation={paginationInformation}
                                                    />
                                                ))
                                            :   displayedContent.map((row, rowIndex) => (
                                                    <SimpleRow 
                                                        key={rowIndex} 
                                                        setControlIndex={() => setControlIndex(rowIndex)} 
                                                        row={row} 
                                                        isControlIndex={rowIndex === controlIndex} 
                                                        rowIndex={rowIndex} 
                                                        hasControlsColumn={hasControlsColumn}
                                                    />
                                                ))
                                        }

                                        {/* pagination loading spinner */}
                                        {isLoadingMore && 
                                            <td 
                                                className='rc-no-data-cell rc-load-more-spinner' 
                                                colSpan={simpleTableContent.columns.length + ((isDragAndDrop || hasControlsColumn) ? 1 : 0)}
                                            >
                                                <LoadingSpinner size={8}/>
                                            </td>
                                        }
                                    </tbody>
                                )   
                    }
                </table>
                
                {isInfiniteScroll && <div data-testid="rc-infinite-scroll" ref={infiniteScrollRef} />}
            </div>
        </DndProvider>
    );
};

export default SimpleTable;